import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import styles from "./SocialMedia.module.css";

import { getImgDetail } from "./PortalState/dataTransformerUtilities";
import { CategoriesFields, SectionNames } from "./PortalState/SectionDataMetaData";

import UploadLogo from "../../../components/UploadLogo";
import SettingTextField from "../../../components/SettingTextField";

const CategoryGroup = (props) => {
    let { data: categoryGroupData, errors, onCategoriesListEdit, onDeleteEntry, imageLoading, index, uploadLogoFile, handleChange, isLast } = props;

    const errorSx = { color: "#d32f2f", fontSize: "12px", fontFamily: "GilroyMedium" };

    const onDelete = () => {
        onDeleteEntry(SectionNames.categoryGroupsTab, index);
    };

    const onInputChange = (field, value) => {
        handleChange(SectionNames.categoryGroupsTab, field, value, index);
    };

    const onFileUpload = (file, data) => {
        uploadLogoFile(file, data, index, SectionNames.categoryGroupsTab);
    }

    return (
        <Grid
            item
            container
            xs={12}
            justifyContent={"space-between"}
            sx={isLast ? {} : { borderBottom: "2px solid #AAA" }}
            pb={2}
            mb={isLast ? 0 : 2}
        >
            <Grid item xs={12} md={5.8} mt={2}>
                <Box mb={1}>
                    <Typography className={styles.textInputLabel}>Group Name</Typography>
                </Box>
                <Box>
                    <SettingTextField
                        page={"CategoryGroup"}
                        editable={true}
                        value={categoryGroupData?.[CategoriesFields.name]}
                        setValue={(val) => onInputChange(CategoriesFields.name, val)}
                        placeholder={""}
                        required={true}
                        variant={"filled"}
                        border={"1px solid #AAA"}
                        error={errors[SectionNames.categoryGroupsTab].has(`${index}_${CategoriesFields.name}`) ?
                            errors[SectionNames.categoryGroupsTab].get(`${index}_${CategoriesFields.name}`) : ""}
                        errorStyles={errorSx}
                    />
                </Box>
            </Grid>
            <Grid item xs={12} md={5.8} mt={2}>
                <Box mb={1}>
                    <Typography className={styles.textInputLabel}>Categories</Typography>
                </Box>
                <Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: '0.75rem', width: "100%" }}>
                        <Stack direction="row" spacing={1} sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-start", flexWrap: "wrap", gap: "2px 0.325rem" }}>
                            {categoryGroupData[CategoriesFields.categories].map(category => <Chip
                                key={category._id}
                                style={{ marginLeft: 0 }}
                                label={category.name}
                                variant="outlined"
                                onDelete={() => props.onRemoveCategory(categoryGroupData, category, index)}
                            />)}
                        </Stack>
                        <Chip
                            sx={{
                                fontWeight: '500',
                                lineHeight: '1.75rem',
                                letterSpacing: '0.02857em',
                                textTransform: 'uppercase',
                                border: '1px solid'
                            }}
                            label="Edit"
                            variant="outlined"
                            onClick={() => onCategoriesListEdit(categoryGroupData, index)}
                        />
                    </Box>
                    <Box>
                        {errors[SectionNames.categoryGroupsTab].has(`${index}_${CategoriesFields.categories}`) && (
                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", fontFamily: "GilroyMedium" }}>
                                {errors[SectionNames.categoryGroupsTab].get(`${index}_${CategoriesFields.categories}`)}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Grid>

            <Grid item xs={12} md={5.8} mt={2}>
                <Box mb={1}>
                    <Typography className={styles.textInputLabel}>Image width</Typography>
                </Box>
                <Box>
                    <SettingTextField
                        page={"CategoryGroup"}
                        editable={true}
                        value={categoryGroupData[CategoriesFields.imageWidth] || ""}
                        setValue={(val) =>
                            onInputChange(CategoriesFields.imageWidth, val.replace(/[^0-9.]/g, ""))
                        }
                        placeholder={""}
                        required={true}
                        variant={"filled"}
                        border={"1px solid #AAA"}
                        error={errors[SectionNames.categoryGroupsTab].has(`${index}_${CategoriesFields.imageWidth}`) ?
                            errors[SectionNames.categoryGroupsTab].get(`${index}_${CategoriesFields.imageWidth}`) : ""}
                        errorStyles={errorSx}
                    />
                </Box>
            </Grid>
            <Grid item xs={12} md={5.8} mt={2}>
                <Box mb={1}>
                    <Typography className={styles.textInputLabel}>Image height</Typography>
                </Box>
                <Box>
                    <SettingTextField
                        page={"CategoryGroup"}
                        editable={true}
                        value={categoryGroupData[CategoriesFields.imageHeight] || ""}
                        setValue={(val) =>
                            onInputChange(CategoriesFields.imageHeight, val.replace(/[^0-9.]/g, ""))
                        }
                        placeholder={""}
                        required={true}
                        variant={"filled"}
                        border={"1px solid #AAA"}
                        error={errors[SectionNames.categoryGroupsTab].has(`${index}_${CategoriesFields.imageHeight}`) ?
                            errors[SectionNames.categoryGroupsTab].get(`${index}_${CategoriesFields.imageHeight}`) : ""}
                        errorStyles={errorSx}
                    />
                </Box>
            </Grid>
            <Grid item xs={12} md={5.8} mt={2}>
                <Box mr={2} mb={1}>
                    <UploadLogo
                        type={index}
                        sectionName={SectionNames.categoryGroupsTab}
                        uploadFile={onFileUpload}
                        imageLoading={imageLoading}
                        logoImg={
                            typeof categoryGroupData?.[CategoriesFields.img] == "string" && categoryGroupData?.[CategoriesFields.img]
                                ? getImgDetail(categoryGroupData?.[CategoriesFields.img], "CategoryGroup")
                                : categoryGroupData?.[CategoriesFields.img]
                                    ? categoryGroupData?.[CategoriesFields.img]
                                    : ""
                        }
                        imageType={props.imageType}
                        placeholder={"Category Group LOGO"}
                        showViewUploadIcon={true}
                        onRemove={() => onInputChange("img", "")}
                    />
                    {errors[SectionNames.categoryGroupsTab].has(`${index}_${CategoriesFields.img}`) && (
                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", fontFamily: "GilroyMedium" }}>
                            {errors[SectionNames.categoryGroupsTab].get(`${index}_${CategoriesFields.img}`)}
                        </Typography>
                    )}
                </Box>
            </Grid>
            <Grid container item xs={12} mt={2} justifyContent={"flex-end"}>
                <Button
                    type="button"
                    disabled={imageLoading}
                    className={styles.deleteBtn}
                    sx={{
                        opacity: imageLoading ? 0.2 : 1,
                    }}
                    onClick={imageLoading ? null : onDelete}
                >
                    Delete
                </Button>
            </Grid>
        </Grid>
    );
};

export default CategoryGroup;
